<template>
  <div>
    <vue-tabs @tab-change="handleTabChange" v-model="tabName" centered>
      <v-tab title="Info"><view-info></view-info></v-tab>
      <v-tab title="Position"><view-position></view-position></v-tab>
      <v-tab title="Fjärrsupport"><view-remotesupport></view-remotesupport></v-tab>
      <v-tab title="Klienter"><view-clients></view-clients></v-tab>
      <v-tab v-if="$root.gotNXT" title="WiFi"><view-wifi></view-wifi></v-tab>
      <v-tab v-if="$root.isVersionGte('1.6.0')" title="Backuper"><view-backups></view-backups></v-tab>
      <v-tab v-if="$root.isCloud" title="Moln"><view-cloud></view-cloud></v-tab>
    </vue-tabs>
  </div>
</template>

<script>
  import {VueTabs, VTab} from 'vue-nav-tabs'
  import 'vue-nav-tabs/themes/paper.css'
  import viewUppdateringar from './installningar_uppdateringar'
  import viewPosition from './installningar_position'
  import viewInfo from './installningar_info'
  import viewRemotesupport from './installningar_remotesupport'
  import viewClients from './installningar_clients'
  import viewCloud from './installningar_cloud'
  import viewBackups from './installningar_backups'
  import viewWifi from './installningar_wifi'
  import viewTests from './installningar_tester'
  import { eventbus } from '../eventbus.js'

export default {
  name: 'installningar',
  components: {
    VueTabs,
    VTab,
    viewUppdateringar,
    viewPosition,
    viewInfo,
    viewRemotesupport,
    viewClients,
    viewCloud,
    viewBackups,
    viewWifi,
    viewTests
  },
  data () {
    return {
      tabName: ''
    }
  },
  mounted () {
    if (this.$route.name === 'installningar_wifi') {
      setTimeout(() => this.tabName = 'WiFi', 1000)
    }
  },
  methods: {
    handleTabChange (tabIndex, newTab, oldTab) {
      eventbus.$emit('tab-change', tabIndex, newTab, oldTab)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/installningar.vue